export function createQueryEncode(transform: (record: Record<string, any>) => string, translate: (encodeString: string) => Record<string, any>) {
  return {
    encode(record: Record<string, any>): never | { query: string } {
      if (record === null || typeof record !== 'object' || Array.isArray(record)) {
        throw new Error('入参必须为对象')
      }
      const result = { query: '' }
      try {
        result.query = transform(record)
      } catch (e) {
        return result
        // throw new Error('query编码失败')
      }
      return result
    },
    decode<T extends Record<string, any> = Record<string, any>>(encodeString: string): never | T {
      if (typeof encodeString !== 'string') {
        throw new Error('encode data类型不正确')
      }
      let result = {}
      try {
        result = translate(encodeString)
      } catch (e) {
        return result
        // throw new Error('query解码失败')
      }
      return result as T
    },
  }
}

const queryEncode = createQueryEncode(
  record => btoa(encodeURIComponent(JSON.stringify(record))),
  encodeString => JSON.parse(decodeURIComponent(atob(decodeURIComponent(encodeString)))),
)

export default queryEncode